import debounce from '~/utils/events/debounce';
import {setLoading} from '../Store/creators/common';
import {setFilter} from '../Store/creators/filter';
import {setFloor} from '../Store/creators/visualData';
import {dispatch} from '../Store/index';
// import {StateVisualFloor, StateVisualFloorMapItem} from '../Store/State';
import sendVisualRequest from '../utils/sendVisualRequest';

// tslint:disable:max-line-length
/* const data = {
	floor: 2,
	image: '/images/choose-visual/floors/05/02.svg',
	map: [
		{
			path: 'M1080.1 637.9l20.3 35.1 119.7-69.1 33.7 58.4-216.5 125.6-54.2-93.5z',
			target: 462952,
			roomType: '3 комнаты (евро)',
			squareTotal: 70.79,
			totalCost: 4522281,
		},
		{
			path: 'M936.1 555.1l67.6-.1 42.4 24.3 34 58.6-98 56.9-45.9-26.4z',
			target: 462953,
			roomType: '1 комната',
			squareTotal: 43.72,
			totalCost: 3022243,
		},
		{
			path: 'M831.5 555.1h104.6l.1 113.3-104.7 1z',
			target: 462954,
			roomType: '1 комната',
			squareTotal: 37.26,
			totalCost: 2922246,
		},
		{
			path: 'M648.2 523.5l-.2 44.3-22.1.2.2 81.7 83.5.2.1 18.9 121.8.6V555.1h-11.9l.3-27.7-38.3-.4.4 44.1-36.9-.7.3-46.5z',
			target: 462955,
			roomType: '3 комнаты (евро)',
			squareTotal: 77.91,
			totalCost: 4722248,
		},
		{
			path: 'M648.1 472.1h-22.3l-.1-81.6 89.2-.2v25l172-.8V528l-105.3-1 .4 44.1-36.9-.7.3-46.5-97.2-.4z',
			target: 462956,
			roomType: '4 комнаты (евро)',
			squareTotal: 99.99,
			totalCost: 5222249,
		},
		{
			path: 'M886.9 414.5V528h118.2l42-24.5 35.5-62.6-97.6-57.8-18 30.7z',
			target: 462957,
			roomType: '3 комнаты (евро)',
			squareTotal: 63.26,
			totalCost: 4122271,
		},
		{
			path: 'M985 383.1l57.7-91.9 217.2 123.1-55.7 96.6-121.6-70z',
			target: 462958,
			roomType: '3 комнаты',
			squareTotal: 89.67,
			totalCost: 4922242,
		},
	],
}; */

async function fetchVisualFloor( floor: number ): Promise<void>
{
	dispatch( setLoading( true ) );
	
	const serverData = await sendVisualRequest( {floor} );
	
	/* const availableTargets = new Set<string | number>();
	
	if ( serverData.floor && serverData.floor.map )
	{
		for ( const item of serverData.floor.map )
		{
			availableTargets.add( item.target );
		}
	}
	
	const viewData: StateVisualFloor = {
		...data,
		floor,
		map: data.map.filter(
			( {target}: StateVisualFloorMapItem ): boolean =>
			{
				return availableTargets.has( target );
			},
		),
	}; */
	
	if ( serverData.floor )
	{
		dispatch( setFloor( serverData.floor ) );
	}
	
	// TODO:
	dispatch(
		setFilter( serverData.filter ),
	);
	
	dispatch( setLoading( false ) );
}

const debouncedFetchVisualFloor = debounce( fetchVisualFloor, 200 );

/**
 * Module.
 */
export {
	fetchVisualFloor as default,
	debouncedFetchVisualFloor,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/asyncActions/fetchVisualFloor.ts